/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ queued: NonNullable<unknown>, skipped: NonNullable<unknown> }} Calendar_Sync_QueuedInputs */

const cs_calendar_sync_queued = /** @type {(inputs: Calendar_Sync_QueuedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zařazeno ${i?.queued} úkolů k synchronizaci (${i?.skipped} přeskočeno)`)
};

const en_calendar_sync_queued = /** @type {(inputs: Calendar_Sync_QueuedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Queued ${i?.queued} tasks to sync (${i?.skipped} skipped)`)
};

/**
* | output |
* | --- |
* | "Queued {queued} tasks to sync ({skipped} skipped)" |
*
* @param {Calendar_Sync_QueuedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_sync_queued = /** @type {((inputs: Calendar_Sync_QueuedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Sync_QueuedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_sync_queued(inputs)
	return cs_calendar_sync_queued(inputs)
});